import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-dialog-close',
  styleUrls: ['./dialog-close.component.less'],
  template: `
    <rt-button
      variant="plain small-x no-padding only-icon"
      [rtTooltip]="closeTooltip! | translate"
      [rtTooltipPosition]="'left'"
      [hasNoHoverState]="true"
    >
      <rt-icon name="close" size="medium"></rt-icon>
    </rt-button>
  `,
})
export class DialogCloseComponent {
  @Input() public closeTooltip?: string = 'rtu.dialog.close_tooltip';
}
